import { render, staticRenderFns } from "./ClientComplianceConfigModal.vue?vue&type=template&id=0a18dc22&scoped=true"
import script from "./ClientComplianceConfigModal.vue?vue&type=script&lang=js"
export * from "./ClientComplianceConfigModal.vue?vue&type=script&lang=js"
import style0 from "./ClientComplianceConfigModal.vue?vue&type=style&index=0&id=0a18dc22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a18dc22",
  null
  
)

export default component.exports